import angular from 'angular';
import { trustedHrefDirective, trustedSrcDirective } from './trustedDirective';

angular
	.module('sh.trusted', [])
	.directive('shTrustedHref', trustedHrefDirective)
	.directive('shSrcHref', trustedSrcDirective);
